import { useApolloClient } from '@apollo/client'
import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  BulkUpdateFolderDocument,
  BulkUpdateFolderMutation,
  BulkUpdateFolderMutationVariables,
  DocumentsDataCollectionDocument,
  DocumentsDocument,
  EmployeeFoldersDocument,
  FoldersDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useBulkUpdateFolderDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const client = useApolloClient()
  const [bulkUpdateFolderMutation, { loading }] = useMutation(BulkUpdateFolderDocument, {
    extractorFn: (data: BulkUpdateFolderMutation) =>
      data.documentsMutations.bulkUpdateFolderDocumentsDocument,
  })

  return {
    loading,
    async bulkUpdateFolder(variables: BulkUpdateFolderMutationVariables) {
      const result = await bulkUpdateFolderMutation({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })

      client.refetchQueries({
        include: [DocumentsDataCollectionDocument, FoldersDocument, EmployeeFoldersDocument],
      })

      return result
    },
  }
}

export default useBulkUpdateFolderDocument
